import axios, { AxiosResponse } from "axios";
import { Preferences, UserPreference } from "../lib/types/UserPreference";
import { ApiUtils } from "./ApiUtils";

export type UserPreferencesRequest = {
  username: string;
  preferences: UserPreference;
};

export class UserApi {
  private static readonly _baseUrl = ApiUtils.getBaseApiUrl();

  public static getUserPreferences(
    username: string
  ): Promise<AxiosResponse<UserPreference>> {
    return axios.get(
      `${this._baseUrl}/userPreferences?email=${username.toLowerCase()}`
    );
  }

  public static updateUserPreferences(
    request: any
  ): Promise<AxiosResponse<{ successful: boolean; message: string }>> {
    return axios.put(`${this._baseUrl}/userPreferences/${request.id}`, request);
  }

  public static saveUserPreferences(
    username: string,
    preferences: Preferences
  ) {
    const request = {
      username,
      preferences,
    };

    return axios.post(`${this._baseUrl}/userPreferences`, request);
  }

  public static getUserBalance(
    username: string | undefined
  ): Promise<AxiosResponse<{ balance: number }>> {
    return axios.get(
      `${this._baseUrl}/userbalance?email=${username?.toLowerCase()}`
    );
  }

  public static updateUserBalance(
    username: string | undefined,
    reduction: string
  ): Promise<AxiosResponse<number>> {
    return axios.put(
      `${this._baseUrl}/userbalance?email=${username?.toLowerCase()}`,
      { reduction }
    );
  }
}
